import Api from '../Api';
import HtmlHelpers from '../HtmlHelpers';
const ListFunctions = {};
ListFunctions.resetFilters = async (storageName, tableState) => {
  localStorage.removeItem("".concat(storageName, "_sort"));
  localStorage.removeItem("".concat(storageName, "_filter"));
  await tableState.current.setState({
    filtered: [],
    sorted: []
  });
  await tableState.current.props.onFetchData();
};
ListFunctions.onFilteredChange = (storageName, filtered) => ListFunctions.storageChange("".concat(storageName, "_filter"), filtered || []);
ListFunctions.onSortChange = (storageName, sorted) => ListFunctions.storageChange("".concat(storageName, "_sort"), sorted || []);
ListFunctions.storageChange = (storageName, value) => {
  if (storageName !== null) {
    localStorage.setItem(storageName, JSON.stringify(value));
  }
};
ListFunctions.getFiltered = storageName => ListFunctions.getStorage("".concat(storageName || '', "_filter"));
ListFunctions.getSorted = storageName => ListFunctions.getStorage("".concat(storageName || '', "_sort"));
ListFunctions.getStorage = storageName => {
  let data = [];
  const storage = localStorage.getItem(storageName);
  if (storageName !== null && storage !== null) {
    data = JSON.parse(storage);
  }
  return data;
};
ListFunctions.fetchData = async options => {
  // options listApi, params, storageName, innerTableRef.current
  let data = [];
  let apiListErrors = [];
  const includes = {};
  let pages = null;
  const additonalInfo = {};
  const sendAsData = options.sendAsData || false;
  const apiFilters = await ListFunctions.listParams(options);
  const params = sendAsData ? apiFilters : apiFilters;
  const requestType = sendAsData ? 'usePost' : 'useGet';
  await ListFunctions[requestType](options, params).then(response => {
    if (response.data !== undefined) {
      data = response.data.map(d => d.attributes);
    }
    if (response.errors !== undefined) {
      apiListErrors = HtmlHelpers.convertRailsErrors(response.errors);
    }
    if (response.included !== undefined) {
      response.included.forEach(d => {
        const uuid2 = d.attributes.uuid;
        if (includes[d.type]) {
          includes[d.type][uuid2] = d.attributes;
        } else {
          includes[d.type] = {
            [uuid2]: d.attributes
          };
        }
      });
    }
    pages = response.page_count;
    const handled = ['data', 'errors', 'included', 'page_count'];
    const additonalKeys = Object.keys(response).filter(k => !handled.includes(k));
    additonalKeys.forEach(key => additonalInfo[key] = response[key]);
  });
  return {
    data,
    pages,
    includes,
    apiListErrors,
    additonalInfo,
    loading: false
  };
};
ListFunctions.useGet = (options, params) => Api.crudList(options.auth, options.listApi, params, options.apiVersion);
ListFunctions.usePost = (options, params) => {
  params.query_name = options.queryName;
  return Api.crudCreate(options.auth, 'lists', JSON.stringify(params), options.apiVersion);
};
ListFunctions.listParams = options => {
  const listParams = options.params || {};
  if (options.params) {
    const storageName = options.storageName;
    const innerTableRef = options.innerTableRef ? options.innerTableRef.state : {};
    listParams.page = innerTableRef.page || 0;
    listParams.pageSize = innerTableRef.pageSize || 20;
    let filter = innerTableRef.filtered || ListFunctions.getFiltered(storageName) || [];
    filter = filter.concat(options.params.filtered || []);
    listParams.filtered = JSON.stringify(filter);
    let sorted = innerTableRef.sorted || ListFunctions.getSorted(storageName) || [];
    if (HtmlHelpers.isEmpty(sorted) && HtmlHelpers.isNotEmpty(options.params.sorted)) {
      sorted = options.params.sorted;
    }
    listParams.sorted = JSON.stringify(sorted);
    if (innerTableRef.sorted) {
      ListFunctions.onSortChange(storageName, innerTableRef.sorted);
    }
  }
  return HtmlHelpers.isEmpty(listParams) ? null : listParams;
};
export default ListFunctions;